import { useEffect } from 'react';
import { useAppDispatch } from '../redux/hooks';
import { setChildPageTitle } from '../redux/reducers/pageTitleSlice';

export const useChildPageTitle = (title: string | null | undefined, piiUserId?: string | null): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setChildPageTitle({ title: title || null, piiUserId: piiUserId ?? null }));
    return () => {
      dispatch(setChildPageTitle({ title: null, piiUserId: null }));
    };
  }, [title, piiUserId, dispatch]);
};
